<template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <v-label><b>{{ label }}</b></v-label>
    <s-select-generic
      v-if="produceID && produceID > 0"
      class="text"
      itemvalue="NtpID"
      :disabled="disabled"
      :value="value"
      id="NtpID" itemtext="Supervice"
      :return-object="returnObject"
      @input="input($event)"
      :config="config"
      :full="full"
      :text="text"
      :clearable="clearable"
    >
    </s-select-generic>
    <v-select
      v-else
      disabled
      outlined
      dense
      placeholder="Seleccione productor primero"
      hide-details="auto"
      class="text"
    >
    </v-select>
  </div>
</template>

<script>
import _sService from "@/services/Technicalassistance/AdvanceProducerService.js";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    produceID:{
      type: Number,
      default: 0,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },    
    full: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(value) {
      this.item = value;
    },
    produceID(){
        this.config.params.PrdID = this.produceID;
    }
  },
  methods: {
    input(val) {
      this.$emit("input", val);
    },
  },
  data: () => ({
    item: 0,
    val: "",
    items: [],
    config: {},
  }),

  created() {
    this.config = {
      url: _sService.getUrlFarmSupervisorbyProducer(),
      title: this.label,
      params: { search: "", requestID: this.$fun.getUserID(), PrdID: this.produceID},
    };
  },
};
</script>
